window.baseurl = window.baseurl || '';
__webpack_public_path__ = window.baseurl + __webpack_public_path__;
